export default __webpack_public_path__ + "static/media/Smriti.02bdb4b0.png";